import React, { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, RotateCw } from "lucide-react";
import { Input } from "@/components/ui-kit";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";

export const OtpStep = ({ phone, onDone, onBack }: { phone: string; onDone: () => void; onBack: () => void }) => {
  const { t } = usePrefs();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const verify = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/customer/verify", { phone, code });
      toast.success(t("cl.activated"));
      onDone();
    } catch (err) {
      setError(errorText(err, t));
    } finally {
      setBusy(false);
    }
  };
  const resend = async () => {
    try { await api.post("/auth/customer/resend", { phone }); toast.success(t("cl.resent")); } catch (err) { toast.error(errorText(err, t)); }
  };
  return (
    <div className="space-y-4" data-testid="otp-step">
      <div className="rounded-2xl bg-accent/60 p-4 text-sm flex gap-3">
        <MessageCircle className="h-5 w-5 text-[#25D366] shrink-0 mt-0.5" />
        <p>{t("cl.otpNote")} <b dir="ltr">{phone}</b></p>
      </div>
      <form onSubmit={verify} className="space-y-3">
        <Input dir="ltr" inputMode="numeric" autoComplete="one-time-code" maxLength={6} required value={code} placeholder="••••••"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          data-testid="otp-code-input" className="h-14 rounded-2xl text-center text-2xl font-black tracking-[0.5em]" />
        {error && <p data-testid="otp-error" className="text-sm text-primary font-semibold">{error}</p>}
        <button disabled={busy || code.length !== 6} data-testid="otp-submit" className="w-full h-12 rounded-full bg-primary text-primary-foreground font-bold disabled:opacity-60">{busy ? t("common.loading") : t("cl.activate")}</button>
      </form>
      <div className="flex items-center justify-between text-sm">
        <button type="button" onClick={resend} data-testid="otp-resend" className="inline-flex items-center gap-1.5 font-bold text-primary"><RotateCw className="h-4 w-4" />{t("cl.resend")}</button>
        <button type="button" onClick={onBack} data-testid="otp-back" className="text-muted-foreground font-semibold">{t("cl.back")}</button>
      </div>
    </div>
  );
};
